import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'

import { ReserveTooltipBody } from '../ReserveTooltip/components/ReserveTooltipBody'
import { Tooltip } from 'react-mt-bootstrap'

import { toCssClass } from 'helpers'
import { upgradeAvailability } from 'helpers/buildings'
import { getTargetType, getGroupByReserve } from 'helpers/reserves'
import { getEndDateMessage } from 'helpers/datetime'
import isFunction from 'lodash/isFunction'
import {
  BUILDING_TITLES,
  LEVEL_STRING,
  RESERVE_TITLES,
} from 'helpers/i18n.jsx'

import {
  RESERVE_QUEUE,
  RESERVE_QUEUE_END,
  RESERVE_INFO_LABEL,
  UPGRADE_AVAILABLE,
} from './constants.jsx'

import styles from './BuildingTooltip.scss'
import { RESERVE_TYPES } from 'constants'

export class BuildingTooltip extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        building: PropTypes.object.isRequired,
        settings: PropTypes.object.isRequired,
        isUpgradeAvailable: PropTypes.bool.isRequired,
        reserveQueue: PropTypes.arrayOf(PropTypes.object).isRequired,
        reserveType: PropTypes.string.isRequired,
        bounds: PropTypes.object,
    };
    constructor(props) {
        super(props)
        this.state = { upcomingReserves: 0, productionEnds: null }
    }
    componentWillReceiveProps(nextProps) {
        this.processReserveQueue(nextProps.reserveQueue)
    }
    componentWillMount() {
        this.processReserveQueue(this.props.reserveQueue)
    }
    componentWillUnmount() {
        if (this.timerId) {
            clearTimeout(this.timerId)
        }
    }
    processReserveQueue(reserveQueue) {
        if (this.timerId) {
            clearTimeout(this.timerId)
        }
        const reservesInProgress = reserveQueue
      .filter(
        reserve =>
          reserve.productionEnds !== null &&
          reserve.productionEnds >= Date.now()
      )
      .sort((first, second) => first.productionEnds - second.productionEnds)

        const upcomingReserves = reservesInProgress.length
        const productionEnds =
      !!upcomingReserves &&
      reservesInProgress[reservesInProgress.length - 1].productionEnds

        if (upcomingReserves) {
            this.timerId = setTimeout(
        this.processReserveQueue.bind(this, reserveQueue),
        reservesInProgress[0].productionEnds - Date.now()
      )
        }

        this.setState({ productionEnds, upcomingReserves })
    }
    render() {
        const { level, type } = this.props.building
        const reserveType = this.props.reserveType

    // disable tooltip for inspiration and artillery strike in usual browser
        if (
      !isFunction(window.jsHostQuery) &&
      (reserveType === RESERVE_TYPES.INSPIRATION ||
        reserveType === RESERVE_TYPES.ARTILLERY_STRIKE)
    ) {
            return null
        }
        const reserveInfo = this.props.settings.reserves[reserveType]

        const reserveGroup = getGroupByReserve(reserveType, this.props.settings)
        const bonusValuesArray = Object.values(
      reserveInfo.bonus.values[level - 1].battle_types
    )
        const targetType = getTargetType(reserveGroup, bonusValuesArray)
        const isReserveHasParameters = Boolean(
      reserveInfo.bonus.values[level].parameters
    )

        return (
      <Tooltip id={this.props.id} bounds={this.props.bounds} isWide>
        <div className={cx(styles.base, styles[`base__type-${targetType}`])}>
          <div className={styles.header}>
            <p className={styles.title}>{BUILDING_TITLES[type]}</p>
            <p className={styles.level}>{LEVEL_STRING(level)}</p>
          </div>
          {Boolean(!this.state.upcomingReserves) && (
            <div className={styles.reserveInfo}>{RESERVE_INFO_LABEL}</div>
          )}
          <div className={styles.divider} />
          <div className={styles.reserve}>
            <div className={styles.button}>
              <div className={styles.thumbnail}>
                <div
                    className={cx(
                    styles.image,
                    styles[`image__${toCssClass(reserveType)}`]
                  )}
                />
              </div>
            </div>
            <div className={styles.reserveInfo}>
              <p className={styles.reserveTitle}>
                {RESERVE_TITLES[reserveInfo.type]}
              </p>
              <p className={styles.reserveLevel}>
                <span className={styles.reserveLevelValue}>
                  {LEVEL_STRING(level)}
                </span>
              </p>
            </div>
          </div>
          <ReserveTooltipBody
              reserveType={reserveType}
              reserveInfo={reserveInfo}
              level={level}
          />
          {Boolean(this.state.upcomingReserves) && (
            <div className={styles.statusMessage}>
              {isReserveHasParameters && <div className={styles.divider} />}
              <p className={styles.status}>
                {RESERVE_QUEUE(this.state.upcomingReserves)}
              </p>
              <p className={cx(styles.statusText, styles.finishText)}>
                {RESERVE_QUEUE_END(
                  <span className={styles.finishTime}>
                    {getEndDateMessage(moment(this.state.productionEnds))}
                  </span>
                )}
              </p>
            </div>
          )}
          {Boolean(
            !this.state.upcomingReserves && this.props.isUpgradeAvailable
          ) && (
            <div
                className={cx(
                styles.statusMessage,
                styles.statusMessage__positive
              )}
            >
              {isReserveHasParameters && <div className={styles.divider} />}
              <p className={styles.status}>{UPGRADE_AVAILABLE}</p>
            </div>
          )}
        </div>
      </Tooltip>
        )
    }
}

export const mapStateToProps = (state, { id, building }) => {
    const { settings } = state

    const reserveType = state.settings.buildings[building.type].reserve_type
    const reserveQueue = state.clanReserves[reserveType].filter(
    item => item.level === building.level
  )
    const isUpgradeAvailable = upgradeAvailability(state, building)

    return {
        id,
        building,
        reserveQueue,
        reserveType,
        settings,
        isUpgradeAvailable,
    }
}

export default connect(mapStateToProps)(BuildingTooltip)



// WEBPACK FOOTER //
// ./components/BuildingTooltip/BuildingTooltip.jsx